import { Dialog, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  dialogbox: {
    "& .MuiDialog-paper": {
      width: "90%",
      maxWidth: "800px",
      borderRadius: "14px",
      backgroundColor: theme.palette.background.paper,
      padding: "20px",
      boxSizing: "border-box",
    },
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    color: theme.palette.grey[500],
  },
  container: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    justifyContent: "space-between",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  column: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    // gap: "2px",
    alignItems: "center"
  },
  scrollbarContainer: {
    maxHeight: "300px",
    overflowY: "auto",
    padding: "10px",
    borderRadius: "8px",
    backgroundColor: theme.palette.background.default,
  },
  featureItem: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
}));



function ViewSubscription(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [open, setOpen] = useState(props.open);
  const featureNameList = props.featureNameList;

  const planName = props.planName;
  const price = props.price;

  const visitLimit =
    props.visitorCount !== undefined ? props.visitorCount : props.visitorCount;

  const subscriptionType = props.subscriptionType;

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 42) {
      return text.substring(0, 42) + "...";
    } else {
      return text;
    }
  };

  return (
    <>
      <div>
        <Button
          size="small"
          sx={{
            "&:hover": {
              backgroundColor: "white",
            },
            fontSize: "20px",
            bottom: "160px",
            right: "-16px",
          }}
          onClick={handleOpen}
        >
          {t("SUBSCRIPTIONVIEWFEATURES")}
        </Button>
      </div>
      <Dialog
        open={open}
        className={classes.dialogbox}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <div>
          <IconButton className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
          <div className={classes.container}>
            <div className={classes.column}>
              {planName && (
                <Tooltip title={planName} placement="bottom">
                  <h3>{planName}</h3>
                </Tooltip>
              )}
              {price && <h2 className="xxb"> {price}</h2>}
              {subscriptionType && <p className="ppa">{subscriptionType}</p>}
              {visitLimit && (
                <p className="ppm">
                  {t("SUBSCRIPTIONVISITIONCREATION")}: {visitLimit}
                </p>
              )}
            </div>
            <div className={classes.column}>
              <div className={classes.scrollbarContainer}>
                <ul style={{ padding: 0, listStyleType: "none" }}>
                  {featureNameList.map((feature, index) => (
                    <li key={index} className={classes.featureItem}>
                      <DoneIcon sx={{ fontSize: "18px", color: "green" }} />
                      <Tooltip title={feature}>
                        {handleTextOverflow(feature)}
                      </Tooltip>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Dialog>

    </>
  );
}

export default ViewSubscription;
